module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hWnqN"))).then(() => parcelRequire('ikE14'));